"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var Card = /*#__PURE__*/function (_react$default$PureCo) {
  function Card() {
    _classCallCheck(this, Card);
    return _callSuper(this, Card, arguments);
  }
  _inherits(Card, _react$default$PureCo);
  return _createClass(Card, [{
    key: "clicked",
    value: function clicked(card) {
      this.props.click(card);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        back = _this$props.back,
        size = _this$props.size;
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "".concat(size, "em"),
          height: "".concat(size, "em")
        },
        className: "card" + (!this.props.close ? ' opened' : '') + (this.props.complete ? ' matched' : ''),
        onClick: function onClick() {
          return _this.clicked(_this.props.card);
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "front"
      }, back || '?'), /*#__PURE__*/_react.default.createElement("div", {
        className: "back"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: this.props.card
      })));
    }
  }]);
}(_react.default.PureComponent);
var _default = exports.default = Card;